import React from "react";
import PropTypes from "prop-types";
import { Row, Card, CardBody } from "reactstrap";
import { toFormattedNumber } from "../../../utils/format";

const Item = ({ circleClass, title, valueClass, value, currency }) => {
  return (
    <div className="col-3">
      <div className="d-flex align-items-center">
        <div className={circleClass} />
        <div className="calculator-title ml-1">{title}</div>
      </div>
      <div className={valueClass}>
        {value}
        {currency}
      </div>
    </div>
  );
};
Item.propTypes = {
  circleClass: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.number,
  currency: PropTypes.string,
  valueClass: PropTypes.string
};
Item.defaultProps = {
  circleClass: "circle blue",
  title: "",
  value: 0,
  valueClass: "calculator-value",
  currency: "€"
};
const Calculator = ({ selectedAmount, amount, isExact, currency }) => {
  const totalClassName = isExact ? "calculator-value exact" : "calculator-value no-exact";
  const totalCircleClassName = isExact ? "circle green" : "circle red";
  let computedCircleClassName = "circle green";
  if (selectedAmount > amount) {
    computedCircleClassName = "circle red";
  } else if (selectedAmount < amount) {
    computedCircleClassName = "circle yellow";
  }
  const differenceCircleClassName = isExact ? "circle gray" : "circle red";
  return (
    <Card className="mt-sm-3 ">
      <CardBody>
        <Row class="mb-2">
          <Item
            circleClass="circle blue"
            title="IMPORTE TRANSFERENCIA"
            value={toFormattedNumber(amount)}
            currency={currency}
          />
          <Item
            circleClass={computedCircleClassName}
            title="COMPUTO PARTIDAS"
            value={toFormattedNumber(selectedAmount)}
            currency={currency}
          />
          <Item
            circleClass={differenceCircleClassName}
            title="DIFERENCIA"
            value={toFormattedNumber(amount - selectedAmount)}
            currency={currency}
          />
          <Item
            circleClass={totalCircleClassName}
            title="TOTAL CONCILIACIÓN"
            valueClass={totalClassName}
            value={toFormattedNumber(amount)}
            currency={currency}
          />
        </Row>
      </CardBody>
    </Card>
  );
};

Calculator.propTypes = {
  selectedAmount: PropTypes.number,
  amount: PropTypes.number,
  isExact: PropTypes.bool,
  currency: PropTypes.string
};

Calculator.defaultProps = {
  selectedAmount: 0,
  amount: 0,
  isExact: false,
  currency: "EUR"
};
export default Calculator;
